import type { BrandVoice } from "@gf/shared";

export type StepState = "done" | "todo" | "checking" | "error";
export interface OnboardingStep { id: string; label: string; detail: string; to: string; action: string; state: StepState }
export interface ProgressInputs {
  extension: "checking" | "connected" | "signed_out" | "not_detected";
  instagram: StepState;
  settings: StepState;
  voice?: Partial<BrandVoice>;
  automationEnabled?: boolean;
  outreach: StepState;
  engage: StepState;
  contact: StepState;
}

export function onboardingSteps(input: ProgressInputs): OnboardingStep[] {
  const configured = (done: boolean): StepState => input.settings === "done" ? done ? "done" : "todo" : input.settings;
  const campaign: StepState = input.outreach === "done" || input.engage === "done" ? "done"
    : input.outreach === "error" || input.engage === "error" ? "error"
      : input.outreach === "checking" || input.engage === "checking" ? "checking" : "todo";
  return [
    { id: "extension", label: "Install the extension", detail: "Use GramFather in this Chrome browser.", to: "/extension", action: "Get extension", state: input.extension === "checking" ? "checking" : input.extension === "not_detected" ? "todo" : "done" },
    { id: "instagram", label: "Connect Instagram", detail: "Sign into the extension and open your Instagram account.", to: "/settings?tab=instagram", action: "Connect account", state: input.instagram },
    { id: "voice", label: "Set your brand voice", detail: "Add your business, offer, and ideal customer so replies fit your brand.", to: "/settings?tab=voice", action: "Write your voice", state: configured(!!input.voice?.businessName?.trim() && !!input.voice?.whatYouSell?.trim() && !!input.voice?.idealCustomer?.trim()) },
    { id: "automation", label: "Review and enable automation", detail: "Choose your pacing and active hours, then enable when you're ready.", to: "/settings?tab=automation", action: "Review settings", state: configured(input.automationEnabled === true) },
    { id: "campaign", label: "Create your first campaign", detail: "An Outreach or Engage campaign for this Instagram account counts, including a draft.", to: "/outreach", action: "Create campaign", state: campaign },
    { id: "contact", label: "Add your first CRM contact", detail: "Keep a conversation and its next move together in your pipeline.", to: "/crm/contacts", action: "Open contacts", state: input.contact },
  ];
}

export function queryProgress(query: { isPending: boolean; isError: boolean; data?: { items: unknown[] } }, enabled: boolean): StepState {
  if (!enabled) return "todo";
  if (query.isError) return "error";
  if (query.isPending || !query.data) return "checking";
  return query.data.items.length > 0 ? "done" : "todo";
}
